import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PagedResult } from 'src/store';
import { fetchBulkProgress, fetchBulkReport, fetchBulkReportLogList, fetchBulkReportRecordList, fetchGroupReport } from './thunks';
import { BatchProgress, BulkReport, BulkReportLogList, BulkReportRecord, GroupReport, ReportingBatchState } from './types';

const initialState: ReportingBatchState = {
  paginatedReportLogs: {
    pageNumber: 0,
    pageSize: 25,
    totalNumberOfPages: 0,
    totalNumberOfRecords: 0,
    results: [],
  },
  paginatedReportRecords: {
    pageNumber: 0,
    pageSize: 25,
    totalNumberOfPages: 0,
    totalNumberOfRecords: 0,
    results: [],
  },
  bulkReport: {} as BulkReport,
  batchProgress: undefined,
  groupReport: undefined,
};

export const reportingBatchSlice = createSlice({
  name: '@@reporting-batch',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBulkReportLogList.fulfilled, (state, action: PayloadAction<BulkReportLogList>) => {
      state.paginatedReportLogs = action.payload;
    });
    builder.addCase(fetchBulkReportRecordList.fulfilled, (state, action: PayloadAction<PagedResult<BulkReportRecord>>) => {
      state.paginatedReportRecords = action.payload;
    });
    builder.addCase(fetchBulkReport.fulfilled, (state, action: PayloadAction<BulkReport>) => {
      state.bulkReport = action.payload;
    });
    builder.addCase(fetchBulkProgress.fulfilled, (state, action: PayloadAction<BatchProgress>) => {
      state.batchProgress = action.payload;
    });
    builder.addCase(fetchGroupReport.fulfilled, (state, action: PayloadAction<GroupReport>) => {
      state.groupReport = action.payload;
    });
  },
});
